import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { formularioService } from '../../../../colaborador/services/formulario.service';
import { ViaCepService } from '../../../../colaborador/services/via-cep.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { ConsumidorService } from '../../../services/consumidor.service';
import { RecadastroService } from '../../../services/Recadastro.service'; // Import RecadastroService
import { FinalizarRecadastramentoRequestDto } from '../../../../colaborador/models/Finalizar.Recadastramento.Request.Dto';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'app-edicao-consumidor',
  standalone: false,
  templateUrl: './edicao-consumidor.component.html',
  styleUrls: ['./edicao-consumidor.component.css']
})
export class EdicaoConsumidorComponent implements OnInit {
  fichaForm: FormGroup;
  consumidorId!: string;
  recadastroId!: string; // Added to store recadastroId separately
  modoEdicao: boolean = false; // Novo estado para controlar edição
  aguardando = false;

  fotosLocal: { url: string }[] = [];
  fotosDocumentos: { url: string }[] = [];
  fotoVistoriadorUrl: string = '';
  assinaturaVistoriador: string = '';
  assinaturaAcompanhante: string = '';
  mostrarModalFoto = false;
  fotoSelecionada = '';

  role: string = '';
  isSuperAdmin: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private formularioService: formularioService,
    private consumiodorService: ConsumidorService,
    private viaCepService: ViaCepService,
    private recadastroService: RecadastroService 
  ) {
    this.fichaForm = this.formBuilder.group({
      // Dados básicos do consumidor
      nomeConsumidor: ['', Validators.required],
      cpf: ['', Validators.required],
      telefone: [''],
      cicloDeLeitura: [''],
      numeroImovel: [''],
      referencia: [''],
      dataCadastroOriginal: [{ value: '', disabled: true }], 
      dataRecadastramento: [''],
      lojLoc: [''],
      concessaoExpediente: [''],
      tipoAbastecimento: [''],
      sistemaAbastecimento: [''],
      tipoUtilizacao: ['utilizacao'],

      // Débito
      possuiDebito: [false],
      valorDebito: [''],
      dataInicioDebito: [''],

      // Endereço
      endereco: this.formBuilder.group({
        cep: [''],
        logradouro: [''],
        complemento: [''],
        bairro: [''],
        localidade: [''], 
        uf: [''], 
        numero: ['']
      }),

      // Água
      numeroHidrometro: [''],
      marcacao: [''],
      seloReloj: [''],
      seloVirola: [''],
      ramal: ['ramal'],
      direto: [true],
      filtro: [''],

      // Cisterna
      hacisterna: [false],
      capacidadeCisternaInformada: [''],
      observacoesCisterna: [''],

      // Reservatório
      hareservatorio: [false],
      capacidadeReservatorioElevado: [''],
      observacoesReservatorioElevado: [''],

      // Economia
      tipoEconomia: ['economia'],
      dUnica: ['dunica'],
      numeroDeEconomias: [''], // Adicionado o campo numeroDeEconomias
      numeroDeQuartos: [''],
      numeroDeSalas: [''],
      numeroWcPav: [''],
      numeroDeAlunos: [''],
      banheiros: [''],
      numeroDeBoxes: [''],
      tipoComercio: [''],
      areaMetroQuadrado: [''],
      tipoIndustria: [''],
      outrosAbastecimentos: ['outrosAbastecimento'],

      // Piscina
      existePiscina: [false],
      dimensoesPiscina: [''],

      // Esgoto
      haColetor: [false],
      coletor: [false],
      gap: [false],
      rio: [false],
      valao: [false],
      focaFiltro: [false],
      vala: [false],
      sumid: [false],
      tipoValaValao: [''],

      // Outras informações
      outrasInformacoes: [''],
      extraidoMemo: [''],
      dataExtraidoMemo: [''],

      // Dados do acompanhante
      nomeAcompanhante: [''],
      cpfAcompanhante: [''],
      telefoneAcompanhante: [''],

      // Assinaturas (agora como campos disabled para somente visualização)
      assinaturaVistoriador: [{ value: '', disabled: true }],
      assinaturaAcompanhante: [{ value: '', disabled: true }],

      // Dados do vistoriador (somente leitura)
      nomeVistoriante: [{ value: '', disabled: true }],
      cpfVistoriador: [{ value: '', disabled: true }],
      empresaVistoriador: [{ value: '', disabled: true }]
    });

  }

  ngOnInit(): void {
    // Rola para o topo ao carregar a página
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Adiciona classe de animação suave ao container principal
    setTimeout(() => {
      const mainContainer = document.querySelector('.main-container');
      if (mainContainer) {
        mainContainer.classList.add('fade-in');
      }
    }, 0);

    // Primeiro, verificar se há um recadastroId na URL
    this.route.params.subscribe(params => {
      if (params['id']) {
        // Se tiver ID na rota, usamos ele
        this.recadastroId = params['id'];
      }

      // Continuar com o fluxo normal
      this.carregarDadosFormulario();
    });

    // Ao carregar, garantir que todos os campos estejam desabilitados
    this.fichaForm.disable();
    this.verificarPermissoes();
  }

  verificarPermissoes(): void {
    const userData = localStorage.getItem('usuario');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        this.role = user.role || '';
        this.isSuperAdmin = user.role === 'SuperAdministrador';
      } catch {
        this.role = '';
        this.isSuperAdmin = false;
      }
    }
  }

  carregarDadosFormulario(): void {
    // Tenta preencher o formulário com formEdite do localStorage
    const formEdite = localStorage.getItem('formEdite');
    if (formEdite) {
      try {
        const dados = JSON.parse(formEdite);
        this.processarDadosConsumidor(dados);

      } catch (e) {
        console.error('Erro ao processar formEdite:', e);
      }
    } else {
      // fallback para fluxo antigo se não houver formEdite
      const idJuncao = localStorage.getItem('idJuncao');
      if (!idJuncao) {
        Swal.fire('Erro', 'ID do consumidor não encontrado. Tente novamente.', 'error');
        this.router.navigate(['/admin/consulta-consumidor']);
        return;
      }
      this.aguardando = true;
      this.consumiodorService.consultarConsumidorPorId(idJuncao).subscribe({
        next: (dados) => {
          this.processarDadosConsumidor(dados);
        },
        error: (err) => {
          console.error('Erro ao carregar consumidor:', err);
          Swal.fire('Erro', 'Erro ao carregar dados do consumidor.', 'error');
          this.aguardando = false;
        }
      });
    }
  }

  carregarDadosConsumidor(): void {
    if (this.consumidorId) {
      this.aguardando = true;
      this.consumiodorService.consultarConsumidorPorId(this.consumidorId).subscribe({
        next: (dados) => {

          this.processarDadosConsumidor(dados);
        },
        error: (err) => {
          console.error('Erro ao consultar consumidor:', err);
          this.aguardando = false;
        }
      });
    }
  }

  processarDadosConsumidor(dados: any): void {
    this.recadastroId = dados.recadastroId;

    const formatarData = (dataString: string | null | undefined): string => {
      if (!dataString) return '';
      try {
        return new Date(dataString).toISOString().split('T')[0];
      } catch {
        return '';
      }
    };

    this.fichaForm.patchValue({
      // Dados básicos
      nomeConsumidor: dados.nomeConsumidor || '',
      cpf: dados.cpf || '',
      telefone: dados.telefone || '',
      cicloDeLeitura: dados.cicloDeLeitura || '',
      numeroImovel: dados.numeroImovel || '',
      referencia: dados.referencia || '',
      dataCadastroOriginal: formatarData(dados.dataCadastroOriginal),
      dataRecadastramento: formatarData(dados.dataRecadastramento),
      lojLoc: dados.lojLoc || '',
      concessaoExpediente: dados.concessaoExpediente || '',
      tipoAbastecimento: dados.tipoAbastecimento || '',
      sistemaAbastecimento: dados.sistemaAbastecimento || '',
      tipoUtilizacao: dados.tipoUtilizacao || 'utilizacao',

      // Débito
      possuiDebito: dados.possuiDebito === true || dados.possuiDebito === 'true',
      valorDebito: dados.valorDebito ? Number(dados.valorDebito).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
      dataInicioDebito: formatarData(dados.dataInicioDebito),

      // Endereço
      endereco: {
        cep: dados.endereco?.cep || '',
        logradouro: dados.endereco?.logradouro || '',
        complemento: dados.endereco?.complemento || '',
        bairro: dados.endereco?.bairro || '',
        localidade: dados.endereco?.localidade || dados.endereco?.cidade || '',
        uf: dados.endereco?.uf || dados.endereco?.estado || '',
        numero: dados.endereco?.numero || ''
      },

      // Água
      numeroHidrometro: dados.numeroHidrometro || '',
      marcacao: dados.marcacao || '',
      seloReloj: dados.seloReloj || '',
      seloVirola: dados.seloVirola || '',
      ramal: dados.ramal || 'ramal',
      direto: dados.direto === true || dados.direto === 'true',
      filtro: dados.filtro || '',

      // Cisterna
      hacisterna: dados.haCisterna === true || dados.haCisterna === 'true',
      capacidadeCisternaInformada: dados.capacidadeCisternaInformada || '',
      observacoesCisterna: dados.observacoesCisterna || '',

      // Reservatório
      hareservatorio: dados.haReservatorioElevado === true || dados.haReservatorioElevado === 'true',
      capacidadeReservatorioElevado: dados.capacidadeReservatorioElevadoInformada || '',
      observacoesReservatorioElevado: dados.observacoesReservatorioElevado || '',

      // Economia
      tipoEconomia: dados.tipoEconomia || 'economia',
      dUnica: dados.dUnica || 'dunica',
      numeroDeEconomias: dados.numeroDeEconomias || '', // Adicionado para preencher o campo
      numeroDeQuartos: dados.numeroDeQuartos || '',
      numeroDeSalas: dados.numeroDeSalas || '',
      numeroWcPav: dados.numeroWcPav || '',
      numeroDeAlunos: dados.numeroDeAlunos || '',
      banheiros: dados.banheiros || '',
      numeroDeBoxes: dados.numeroDeBoxes || '',
      tipoComercio: dados.tipoComercio || '',
      areaMetroQuadrado: dados.areaMetroQuadrado || '',
      tipoIndustria: dados.tipoIndustria || '',
      outrosAbastecimentos: dados.outrosAbastecimentos || 'outrosAbastecimento',

      // Piscina
      existePiscina: dados.haPiscina === true || dados.haPiscina === 'SIM',
      dimensoesPiscina: dados.dimensoesPiscina || '',

      // Esgoto
      haColetor: dados.haColetor === true || dados.haColetor === 'SIM',
      coletor: dados.coletor === true || dados.coletor === 'true',
      gap: dados.gap === true || dados.gap === 'SIM',
      rio: dados.rio === true || dados.rio === 'SIM',
      valao: dados.valao === true || dados.valao === 'SIM',
      vala: dados.vala === true || dados.vala === 'SIM',
      sumid: dados.sumidouro === true || dados.sumidouro === 'SIM',
      focaFiltro: dados.focaFiltro === true || dados.focaFiltro === 'SIM',
      tipoValaValao: dados.tipoValaValao || '',

      // Outras informações
      outrasInformacoes: dados.outrasInformacoes || '',
      extraidoMemo: dados.extraidoMemo || '',
      dataExtraidoMemo: formatarData(dados.dataExtraidoMemo),

      // Acompanhante
      nomeAcompanhante: dados.nomeAcompanhante || '',
      cpfAcompanhante: dados.cpfAcompanhante || '',
      telefoneAcompanhante: dados.telefoneAcompanhante || '',

      // Assinaturas
      assinaturaVistoriador: dados.assinaturaVistoriante?.url || '',
      assinaturaAcompanhante: dados.assinaturaAcompanhante?.url || '',

      // Vistoriador
      nomeVistoriante: dados.nomeVistoriante || '',
      cpfVistoriador: dados.cpfVistoriante || '',
      empresaVistoriador: dados.nomeDaEmpresaVistoriante || ''
    });

    this.fotosLocal = dados.fotos || [];
    this.fotosDocumentos = dados.fotosDocumento || [];
    this.fotoVistoriadorUrl = dados.fotoVistoriante || '';
    this.assinaturaVistoriador = dados.assinaturaVistoriante?.url || ''; // Updated to use assinaturaVistoriante.url
    this.assinaturaAcompanhante = dados.assinaturaAcompanhante?.url || ''; // Updated to use assinaturaAcompanhante.url
    // Salvamento opcional
    localStorage.setItem('fichaFormDataRaw', JSON.stringify(dados));
    localStorage.setItem('fichaFormData', JSON.stringify(this.fichaForm.getRawValue()));

    this.aguardando = false;
  }


  onCepChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cep = input.value.replace(/\D/g, '');

    if (cep.length === 8) {
      this.viaCepService.consultaCep(cep).subscribe({
        next: (data) => {
          this.fichaForm.patchValue({
            endereco: {
              logradouro: data.logradouro || '',
              bairro: data.bairro || '',
              localidade: data.localidade || '',
              uf: data.uf || '',
              cep: cep,
              numero: this.fichaForm.get('endereco.numero')?.value || ''
            }
          });
        },
        error: (error) => console.error('Erro ao buscar CEP:', error)
      });
    }
  }

  formatarValorDebito(): void {
    const control = this.fichaForm.get('valorDebito');
    if (!control) return;

    let valor = control.value || '';
    valor = valor.replace(/\D/g, '');
    let valorNumerico = parseFloat(valor) / 100;
    if (isNaN(valorNumerico)) valorNumerico = 0;

    const valorFormatado = valorNumerico.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    control.setValue(valorFormatado, { emitEvent: false });
  }

  iniciarEdicao(): void {
    if (this.modoEdicao) return;

    const usuarioId = localStorage.getItem('usuarioId');
    // Buscar o cadastroId do objeto do consumidor salvo em formEdite
    let cadastroId: string | undefined = undefined;
    const formEdite = localStorage.getItem('formEdite');
    if (formEdite) {
      try {
        const dados = JSON.parse(formEdite);
        cadastroId = dados.cadastroId;
      } catch {}
    }
    if (!cadastroId) {
      Swal.fire('Erro', 'ID de cadastro (cadastroId) não encontrado no consumidor. Não é possível iniciar o recadastramento.', 'error');
      return;
    }
    if (!usuarioId) {
      Swal.fire('Erro', 'Usuário não identificado. Faça login novamente.', 'error');
      return;
    }

    Swal.fire({
      title: 'Iniciando recadastramento...',
      text: 'Aguarde enquanto preparamos a edição.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    this.recadastroService.iniciarRecadastramento({
      usuarioId,
      cadastroId,
      latitudeInicio: '0',
      longitudeInicio: '0'
    }).subscribe({
      next: (response) => {
        Swal.close();
        this.modoEdicao = true;
        this.fichaForm.enable();
        // Manter campos que devem ser readonly desabilitados
        this.fichaForm.get('dataCadastroOriginal')?.disable();
        this.fichaForm.get('assinaturaVistoriador')?.disable();
        this.fichaForm.get('assinaturaAcompanhante')?.disable();
        this.fichaForm.get('nomeVistoriante')?.disable();
        this.fichaForm.get('cpfVistoriador')?.disable();
        this.fichaForm.get('empresaVistoriador')?.disable();
      },
      error: (err) => {
        Swal.close();
        Swal.fire('Erro', 'Não foi possível iniciar o recadastramento.', 'error');
      }
    });
  }

  onSubmit(): void {
    if (!this.modoEdicao) return; // Só permite salvar se estiver em modo edição
    if (this.fichaForm.invalid) {
      Swal.fire('Aviso', 'Por favor, preencha todos os campos obrigatórios.', 'warning');
      return;
    }

    const formData = this.prepareFormData();

    Swal.fire({
      title: 'Salvando...',
      text: 'Enviando dados do consumidor',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    const recadastramentoAtivo = localStorage.getItem('recadastramentoAtivo');
    const dadosRecadastramento = recadastramentoAtivo ? JSON.parse(recadastramentoAtivo) : null;
    const recadastroIdDoStorage = dadosRecadastramento?.recadastroId || this.recadastroId;

    if (!recadastroIdDoStorage) {
      Swal.fire('Erro', 'ID do recadastramento não encontrado. Tente novamente.', 'error');
      return;
    }

    const usuarioId = dadosRecadastramento?.usuarioId || localStorage.getItem('usuarioId');

    this.recadastroService.adicionarRecadastro(recadastroIdDoStorage, usuarioId, formData).pipe(
      switchMap(() => {
        // Skip sending signatures
        return of(null);
      }),
      switchMap(() => {
        // Obter coordenadas para finalizar
        return this.obterCoordenadas();
      }),
      switchMap(coordenadas => {
        // Finalizar recadastramento
        const finalizarRequest: FinalizarRecadastramentoRequestDto = {
          recadastroId: recadastroIdDoStorage,
          latitudeFim: coordenadas.latitude,
          longitudeFim: coordenadas.longitude
        };
        return this.recadastroService.finalizarRecadastramento(finalizarRequest);
      })
    ).subscribe({
      next: () => {
        // Limpar dados do localStorage
        localStorage.removeItem('fichaFormData');
        localStorage.removeItem('fichaFormDataRaw');
        localStorage.removeItem('idJuncao');
        localStorage.removeItem('consumidorData');
        localStorage.removeItem('formEdite');

        Swal.fire({
          title: 'Sucesso!',
          text: 'Dados atualizados e recadastramento finalizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          this.router.navigate(['/admin/consulta-consumidor']);
        });
      },
      error: (err: HttpErrorResponse | Error) => {
        console.error('❌ Erro no processo de submissão:', err);
        let mensagemErro = 'Não foi possível concluir a operação.';

        if (err instanceof HttpErrorResponse && err.error) {
          mensagemErro += `\nErro: ${err.error.error}\nDetalhes: ${err.error.details}`;
        } else if (err.message) {
          mensagemErro += `\nDetalhe: ${err.message}`;
        }
        Swal.fire('Erro', mensagemErro, 'error');
      }
    });
  }

  // Método para obter coordenadas de geolocalização
  private obterCoordenadas(): Promise<{ latitude: string; longitude: string }> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocalização não é suportada por este navegador.'));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString()
          });
        },
        (error) => {
          console.error('Erro ao obter geolocalização. Usando coordenadas padrão (0,0).', error);
          // Fallback para coordenadas padrão ou tratar o erro como preferir
          resolve({ latitude: '0', longitude: '0' }); 
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
      );
    });
  }

  // Helper method to create the FormData for submission
  private prepareFormData(): FormData {
    const formData = new FormData();
    const raw = this.fichaForm.getRawValue();

    // 2. Mapeamento correto para campos de endereço
    const endereco = raw.endereco;
    if (endereco) {
      // Renomear campos para corresponder à API
      const enderecoCompleto = {
        cep: endereco.cep || '',
        logradouro: endereco.logradouro || '',
        complemento: endereco.complemento || '',
        bairro: endereco.bairro || '',
        localidade: endereco?.cidade || endereco.localidade || '',
        uf: endereco?.estado || endereco?.uf || '',
        numero: endereco.numero || ''
      };

      // Append como JSON para garantir compatibilidade
      formData.append('endereco', JSON.stringify(enderecoCompleto));

      // Campos individuais para compatibilidade
      Object.entries(enderecoCompleto).forEach(([key, value]) => {
        formData.append(`endereco.${key}`, value);
      });
    }

    // 3. Correção do valorDebito
    let valorDebitoNumerico: number | null = null;
    const valorDebitoRaw = this.fichaForm.get('valorDebito')?.value;
    if (valorDebitoRaw) {
      const valor = String(valorDebitoRaw).replace(/[R$\s.]/g, '').replace(',', '.');
      valorDebitoNumerico = parseFloat(valor);
      if (isNaN(valorDebitoNumerico)) valorDebitoNumerico = null;

      formData.append('valorDebito', valorDebitoNumerico !== null ? String(valorDebitoNumerico) : '');
    }

    // Lista ampliada de campos para excluir - MODIFICADO: Removidas assinaturas para permitir o envio
    const camposParaExcluir = [
      'fotos', 'fotosDocumento', 'fotoVistoriante',
      'nomeDaEmpresaVistoriante', 'cpfVistoriante',
      'nomeVistoriante', 'cpfVistoriador', 'empresaVistoriador'
      // Removidas as assinaturas da lista de exclusão para permitir o envio
    ];

    // Remover assinaturas do mapeamento de campos - MODIFICADO: Manteve-se o mapeamento de assinaturas
    const mapeamentoCampos: { [key: string]: string } = {
      hacisterna: 'haCisterna',
      hareservatorio: 'haReservatorioElevado',
      existePiscina: 'haPiscina',
      outrosAbastecimentos: 'outrosAbastecimentos',
      tipoValaValao: 'tipoValaValao',
      // Manter mapeamento de assinaturas
      assinaturaVistoriador: 'assinaturaVistorianteUrl',
      assinaturaAcompanhante: 'assinaturaAcompanhanteUrl',
      sumid: 'sumidouro',
      capacidadeReservatorioElevado: 'capacidadeReservatorioElevadoInformada',
      dataInicioDebito: 'dataInicioDebito',
      dataExtraidoMemo: 'dataExtraidoMemo',
      matricula: 'matricula'
    };

    // 5. Tratamento correto para campos booleanos
    const booleanFields: Record<string, string> = {
      haCisterna: raw.hacisterna ? 'true' : 'false',
      haReservatorioElevado: raw.hareservatorio ? 'true' : 'false',
      haPiscina: raw.existePiscina ? 'true' : 'false',
      possuiDebito: raw.possuiDebito ? 'true' : 'false',
      direto: raw.direto ? 'true' : 'false',
      haColetor: raw.haColetor ? 'true' : 'false',
      coletor: raw.coletor ? 'true' : 'false',
      gap: raw.gap ? 'true' : 'false',
      rio: raw.rio ? 'true' : 'false',
      valao: raw.valao ? 'true' : 'false',
      vala: raw.vala ? 'true' : 'false',
      sumidouro: raw.sumid ? 'true' : 'false',
      focaFiltro: raw.focaFiltro ? 'true' : 'false',
      ativo: 'true'  // Incluir campo ativo sempre como true
    };

    // Explicitly handle specific date fields
    if (raw.dataInicioDebito) {
      formData.append('dataInicioDebito', raw.dataInicioDebito);
    }

    if (raw.dataExtraidoMemo) {
      formData.append('dataExtraidoMemo', raw.dataExtraidoMemo);
    }

    // Explicitly handle capacity fields
    if (raw.capacidadeCisternaInformada) {
      formData.append('capacidadeCisternaInformada', raw.capacidadeCisternaInformada);
    }

    if (raw.capacidadeReservatorioElevado) {
      formData.append('capacidadeReservatorioElevadoInformada', raw.capacidadeReservatorioElevado);
    }

    // Then handle the rest of the fields
    Object.entries(raw).forEach(([key, value]) => {
      if (value === null || value === undefined ||
        camposParaExcluir.includes(key) ||
        key === 'endereco' || // Skip address as we handled it separately
        key === 'dataExtraidoMemo' ||
        key === 'capacidadeCisternaInformada' ||
        key === 'capacidadeReservatorioElevado' ||
        key === 'valorDebito' ||  // Skip here since we handled it above
        key === 'dataInicioDebito') return;

      if (booleanFields.hasOwnProperty(key)) {
        formData.append(mapeamentoCampos[key] || key, booleanFields[key]);
        return;
      }

      const nomeCampo = mapeamentoCampos[key] || key;
      formData.append(nomeCampo, String(value));
    });

    // 6. Adicionar campos de metadados que não existem no formulário
    if (this.recadastroId) {
      formData.append('recadastroId', this.recadastroId);
    }

    // Dados da entidade que precisam ser preservados
    const idJuncao = localStorage.getItem('idJuncao');
    if (idJuncao) {
      formData.append('idJuncao', idJuncao);
    }

    // NOVO: Obter as assinaturas do localStorage se disponíveis, ou usar as do componente
    const assinaturaVistorianteLocalStorage = localStorage.getItem('assinaturaVistoriante');
    const assinaturaAcompanhanteLocalStorage = localStorage.getItem('assinaturaAcompanhante');
    
    // Adicionar assinaturas explicitamente ao formData
    if (assinaturaVistorianteLocalStorage) {
      formData.append('assinaturaVistorianteUrl', assinaturaVistorianteLocalStorage);

    } else if (this.assinaturaVistoriador) {
      formData.append('assinaturaVistorianteUrl', this.assinaturaVistoriador);

    }
    
    if (assinaturaAcompanhanteLocalStorage) {
      formData.append('assinaturaAcompanhanteUrl', assinaturaAcompanhanteLocalStorage);

    } else if (this.assinaturaAcompanhante) {
      formData.append('assinaturaAcompanhanteUrl', this.assinaturaAcompanhante);

    }

    return formData;
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = url;
    this.mostrarModalFoto = true;
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
  }

  // Helper method to convert a URL to a File object
  private getFileFromUrl(url: string): File | null {
    if (!url || url.startsWith('http')) {
      return null; 
    }

    const fileName = url.split('/').pop() || 'assinatura.png';
    const blob = new Blob([url], { type: 'image/png' });
    return new File([blob], fileName, { type: 'image/png' });
  }

  handleDeleteConsumer(): void {
    if (!this.isSuperAdmin) {
      Swal.fire({
        title: 'Permissão Negada',
        text: 'Somente SuperAdministrador pode excluir consumidores.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }
    const formEdite = localStorage.getItem('formEdite');
    let idJuncao: string | undefined;
    if (formEdite) {
      try {
        const dados = JSON.parse(formEdite);
        idJuncao = dados.idJuncao;
      } catch {}
    }
    if (!idJuncao) {
      Swal.fire('Erro', 'ID do consumidor não encontrado.', 'error');
      return;
    }
    const usuarioId = localStorage.getItem('usuarioId');
    if (!usuarioId) {
      Swal.fire('Erro', 'Usuário não identificado. Faça login novamente.', 'error');
      return;
    }
    Swal.fire({
      title: 'Confirmação',
      text: 'Tem certeza que deseja excluir este consumidor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.consumiodorService.deletarPorIdJuncao(idJuncao, usuarioId).subscribe({
          next: () => {
            Swal.fire({
              title: 'Sucesso!',
              text: 'Consumidor excluído com sucesso.',
              icon: 'success'
            }).then(() => {
              this.router.navigate(['/admin/consulta-consumidor']);
            });
          },
          error: (err) => {
            Swal.fire({
              title: 'Erro',
              text: 'Ocorreu um erro ao excluir o consumidor. Tente novamente.',
              icon: 'error'
            });
          }
        });
      }
    });
  }

  voltarPagina(): void {
    window.history.back();
  }
}
